import React, { useEffect, useState, useRef } from "react";
import PostByAgg from "../../utils/axios";
import PostFormDataByAgg from "../../utils/axios";
import ModalAlert from "../../components/ModalAlert";
import LottieLoading from "../../components/child/LottieLoading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UploadFiles = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [channel, setChannel] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState("");
  const [modalOpen, setModalOpen] = useState(<div></div>);
  const [selectedDate, setSelectedDate] = useState(null);
  const [file, setFile] = useState(null);

  const fileInputRef = useRef();

  const GetListChannel = () => {
    setIsLoading(true);
    const url = "song/v1/channel/list-active";
    PostByAgg({
      url: url,
      body: {
        channel_name: channel,
      },
      onResponse: onResponseListChannel,
      onError: onErrorListChannel,
    });
  };

  const onResponseListChannel = (response) => {
    console.log("response list channel", response.data);
    if (
      response.data.code === "2002000" &&
      response.data.data &&
      response.data.data.data
    ) {
      setIsLoading(false);
      setChannel(response.data.data.data); // Ensure data is available
    } else {
      setIsLoading(false);
      setChannel([]); // Set an empty array if no data
    }
  };

  const onErrorListChannel = (error) => {
    console.log("error response list channel", error);
    setModalOpen(
      <ModalAlert
        show={true}
        type={"failed"}
        text={error.response.data}
        action={() => {}}
      />,
    );
  };

  const handleChange = (e) => {
    setSelectedChannel(e.target.value);
    console.log(e.target.value);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    console.log("ini file", selectedFile);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("ini Mau Upload");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("channel_code", selectedChannel);
    formData.append("payment_date", selectedDate.toISOString().split("T")[0]);

    PostFormDataByAgg({
      url: "song/v1/payment/song-channel-upload",
      body: formData,
      onResponse: handleFileUploadSuccess,
      onError: handleFileUploadError,
    });
  };

  const handleFileUploadSuccess = (response) => {
    setIsLoading(false);
    if (response.data.code === "2002000") {
      setModalOpen(
        <ModalAlert
          show={true}
          type={"success"}
          text="File uploaded successfully!"
          action={() => {
            setSelectedChannel("");
            setSelectedDate(null);
            setFile(null);

            if (fileInputRef.current) {
              fileInputRef.current.value = ""; // Clear the file input
            }
          }}
        />,
      );
    } else {
      setModalOpen(
        <ModalAlert
          show={true}
          type={"failed"}
          text={response.data.message || "File upload failed!"}
          action={() => {}}
        />,
      );
    }
  };

  const handleFileUploadError = (error) => {
    setIsLoading(false);
    console.error("File upload error", error);
    setModalOpen(
      <ModalAlert
        show={true}
        type={"failed"}
        text="Error uploading file!"
        action={() => {
          setSelectedChannel("");
          setSelectedDate(null);
          setFile(null);

          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Clear the file input
          }
        }}
      />,
    );
  };

  useEffect(() => {
    GetListChannel();
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    console.log(date);
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-lg">
            <div
              className="card-header text-center"
              style={{
                background: "rgba(192, 219, 255, 0.45)",
                backdropFilter: "blur(90px)",
                color: "White",
                padding: "20px",
                borderRadius: "12px",
              }}
            >
              <h4>UPLOAD FILE</h4>
            </div>
            <div className="card-body">
              <p className="text-center">
                Select a file to upload and choose a channel below.
              </p>
              <form onSubmit={handleSubmit}>
                {/* Dropdown Select Channel */}
                <div className="mb-3">
                  <label className="form-label">Select Channel</label>
                  <select
                    id="channel"
                    className="form-select"
                    value={selectedChannel}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Channel</option>
                    {channel.map((channels) => (
                      <option
                        key={channels.channel_code}
                        value={channels.channel_code}
                      >
                        {channels.channel_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="row mb-3">
                  <label className="form-label" htmlFor="paymentDate">
                    Choose Payment Date
                  </label>
                  <div className="grid col-12">
                    <DatePicker
                      id="paymentDate"
                      className="form-control text-md"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      dateFormat="yyyy/MM/dd"
                      style={{ fontSize: "20px" }}
                      placeholderText="Select Payment Date"
                      required
                    />
                  </div>
                </div>

                {/* File Upload */}
                <div className="mb-3">
                  <label className="form-label">Choose File</label>
                  <input
                    required
                    type="file"
                    className="form-control"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                </div>

                {/* Upload Button */}
                <div className="text-center">
                  <button
                    className="btn btn-primary cursor-pointer"
                    type="submit"
                  >
                    <i className="ri-upload-cloud-line me-4"></i>
                    Upload
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {isLoading && <LottieLoading text="Loading..." />}
        {modalOpen}
      </div>
    </div>
  );
};

export default UploadFiles;
